<div class="modal-header">
  <h2 class="modal-title" id="modal-basic-title">
    Upgrade to use
    @if (features.length > 0) {
      {{ featureDisplay | list }}
    }
    @if (features.length === 0) {
      this feature
    }
  </h2>

  <button
    data-dd-action-name="feature-limit-modal.close-button"
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>

<div class="modal-body">
  <p>
    @if (features.length === 1) {
      <span>
        {{ featureDisplay[0] }}
      </span>
      is a feature that's
    }
    @if (features.length > 1) {
      <span>
        {{ featureDisplay | list }}
      </span>
      are features that are
    }
    @if (features.length === 0) {
      This feature is
    }
    not available on your current subscription.
  </p>

  <ng-template
    [authorizeShowElse]="NotPermission"
    [authorizeOrganisation]="OrganisationPermissionType.UpdateSubscription"
  >
    @if (canUpgradeFromApp$ | async) {
      <p>However you can upgrade at anytime.</p>
    }
  </ng-template>

  <ng-template #NotPermission>
    <p>Ask your account admin to update your subscription.</p>
  </ng-template>
</div>

<div class="modal-footer">
  <button
    data-dd-action-name="feature-limit-modal.close-button.footer"
    type="button"
    class="btn btn-outline ms-2"
    (click)="close()"
  >
    Close
  </button>

  <ng-template
    authorizeShow
    [authorizeOrganisation]="OrganisationPermissionType.UpdateSubscription"
  >
    @if (canUpgradeFromApp$ | async) {
      <button
        data-dd-action-name="feature-limit-modal.upgrade-button"
        type="button"
        class="btn btn-primary"
        (click)="upgrade()"
      >
        See Upgrade Options
      </button>
    }
  </ng-template>
</div>
